module.exports = __webpack_public_path__ + "img/bg.217e072b.webp";